import S3 from "aws-sdk/clients/s3";

import { AWS_S3_BASE_URL, AWS_S3_BUCKET } from "./constants";
import { EUploadImageType } from "./enums";
import { ManagedUpload } from "aws-sdk/clients/s3";

const s3 = new S3({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECURITY_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});

export const uploadFile = async (
  image: File,
  type: EUploadImageType,
  id: string | number,
  progressCallback?: (progess: ManagedUpload.Progress) => void
): Promise<string> => {
  try {
    const timestamp =
      new Date().getUTCMilliseconds() + Math.random().toString(16).slice(2);

    const name = image.name;
    const lastDot = name.lastIndexOf(".");

    const ext = name.substring(lastDot + 1);
    const key =
      type === EUploadImageType.CONTRACT
        ? `images/contracts/${id}`
        : `images/users/${id}`;
    const params = {
      Bucket: AWS_S3_BUCKET,
      Key: `${key}/${ext === "pdf" ? `${name}` : `${`${timestamp}.${ext}`}`}`,
      Body: image,
      ACL: "public-read",
    };
    return await new Promise((resolve) => {
      const uploadRequest = s3.upload(
        params,
        function (err: unknown, data: unknown) {
          if (err) {
            throw err;
          }
          resolve(`${AWS_S3_BASE_URL}${params.Key}`);
        }
      );
      if (progressCallback)
        uploadRequest?.on("httpUploadProgress", progressCallback);
    });
  } catch (err) {
    console.error(err);
    throw err;
  }
};
export const getImageBufferByKey = async (key: string) => {
  const params = {
    Bucket: process.env.REACT_APP_AWS_S3_BUCKET || AWS_S3_BUCKET,
    Key: key,
  };
  return new Promise((resolve, reject) => {
    s3.getObject(params, (err, data) => {
      if (!err) {
        resolve(data.Body);
      } else {
        reject(err);
      }
    });
  });
};
